export default "__VITE_ASSET__dcf894f7__"